module.exports = __webpack_public_path__ + "img/home_middel_left.9688bf53.png";